import React from 'react';
import { Box, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { sidebar } from '../../theme';

// Item de navegación del sidebar navy — ver README.md (Shell).
// Comparte el mismo estilo activo/inactivo entre NavLinks y los sub-menús
// (Administracion, Security, Configurations) para no duplicarlo 4 veces.
const NavItem = ({ to, icon, label, badge, end, sub, onClick }) => {
	return (
		<NavLink to={to} end={end} onClick={onClick} style={{ textDecoration: 'none' }}>
			{({ isActive }) => (
				<Box
					sx={{
						position: 'relative',
						display: 'flex',
						alignItems: 'center',
						gap: sub ? '10px' : '12px',
						padding: sub ? '8px 12px 8px 14px' : '10px 14px',
						borderRadius: '9px',
						cursor: 'pointer',
						marginBottom: '2px',
						color: isActive ? '#fff' : sidebar.itemColor,
						backgroundColor: isActive ? sidebar.activeBg : 'transparent',
						'&:hover': !isActive ? { backgroundColor: 'rgba(255,255,255,.06)', color: '#e8edf3' } : undefined
					}}
				>
					{isActive ? (
						<Box
							sx={{
								position: 'absolute',
								left: 0,
								top: 8,
								bottom: 8,
								width: 3,
								borderRadius: '0 3px 3px 0',
								backgroundColor: sidebar.activeBar
							}}
						/>
					) : null}
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: sub ? 18 : 20,
							color: isActive ? sidebar.activeBar : sidebar.iconColor,
							flexShrink: 0
						}}
					>
						{icon}
					</Box>
					<Typography sx={{ fontSize: sub ? 12.5 : 13.5, fontWeight: 500, flex: 1, minWidth: 0 }}>{label}</Typography>
					{badge ? (
						<Box
							component="span"
							sx={{
								backgroundColor: '#e5484d',
								color: '#fff',
								fontSize: 10.5,
								fontWeight: 600,
								padding: '1px 7px',
								borderRadius: '20px',
								fontFamily: "'IBM Plex Mono', monospace"
							}}
						>
							{badge}
						</Box>
					) : null}
				</Box>
			)}
		</NavLink>
	);
};

export default NavItem;
